export const SAVED_MEAL_NAME_MAX = 200;
export const SAVED_MEAL_DESCRIPTION_MAX = 2000;
export const SAVED_MEAL_MAX_LINES = 50;
export const SAVED_MEAL_MAX_KCAL = 10_000;
export const SAVED_MEAL_MAX_MACRO_GRAMS = 1_000;
export const SAVED_MEAL_MAX_QUANTITY_GRAMS = 10_000;
export const SEARCH_DEBOUNCE_MS = 300;
export const DEFAULT_LINE_QUANTITY_GRAMS = 100;
export const SAVED_MEAL_PICKER_LIMIT = 10;
export const RECENT_LINE_INGREDIENTS_FETCH_LIMIT = 50;
export const RECENT_LINE_INGREDIENTS_VISIBLE_LIMIT = 10;
export const RECENT_LINE_INGREDIENTS_STALE_TIME_MS = 60_000;
